import ShareIcon from './ShareIcon';

function Compose({ i, n, hide_n, cursor, word, shadow_word, move, paused, disabled, guessed_data, exhausted, fast, last_key, _last_key, sharing, onShare, cappedViolations, permViolations, crystalViolations, strategicMode, nextWordCount, pendingOptConstraints, magicPattern }) {
  const share_button = (
    <button key='copy' className="meta copy" onClick={() => onShare(i)}>
      <ShareIcon />
    </button>
  );
  const rep_div = (guessed_data === undefined || guessed_data.rep === 1 ? null : <div className="rep">{guessed_data.rep}</div>);
  const seq_div = (guessed_data === undefined ? null : <div className="seq">{guessed_data.seq}</div>);
  const n_div = (hide_n || word.join("").search("  ") === -1 ? null : <div className="n">{n}</div>);
  const exhausted_div = (exhausted === -1 ? <div className="rep">.</div> : (exhausted > 0 ? <div className="rep">{exhausted}</div> : null));
  const x = [...word.keys()].map(i => {
    let className = "b" + (n > 7 ? " shrink" : "") + (!disabled && !sharing && i === cursor ? " c" : "") + (disabled ? " d" : "") + (i === last_key.cursor && Date.now() - last_key.t < fast && last_key.flash ? " x" : "") + (i === last_key.cursor && Date.now() - last_key.t < fast && last_key.flash_red ? " y" : "");
    if (magicPattern === "CACHE_FAIL" && i === 0) {
      className += " magic-error";
    } else if (magicPattern && magicPattern !== "CACHE_FAIL" && magicPattern[i]) {
      className += (magicPattern[i] !== 'X' ? " " + magicPattern[i] : "") + " magic";
    }

    if (cappedViolations.includes(i)) {
      className += " capped-violation";
    } else if (crystalViolations && crystalViolations.includes(i)) {
      className += " crystal-violation";
    } else if (cappedViolations.length === 0 && permViolations[1].includes(i)) {
      className += " mc-violation";
    } else if (cappedViolations.length === 0 && permViolations[2].includes(i)) {
      className += " mc-violation-mild";
    }

    if (word[i] === ' ' && shadow_word[i] !== ' ') {
      className += " shadow";
    }
    if (word[i] === '.') {
      className += " dot";
    }

    if (i === last_key.cursor && Date.now() - last_key.t < fast && (last_key.flash || last_key.disabled)) {
      setTimeout(() => {
        _last_key((current_last_key) => last_key === current_last_key ? { ...last_key, flash: false, flash_red: false, disabled: false } : current_last_key);
      }, fast);
    }

    const magic_div = (magicPattern === "CACHE_FAIL" && i === 0) ? 
        <div className="magic-icon" style={{ position: 'absolute', top: '-18px', left: '0px', color: '#ff4444', fontWeight: 'bold', fontSize: '11px', whiteSpace: 'nowrap', zIndex: 10 }}>CACHE ERR</div> :
        (magicPattern && magicPattern !== "CACHE_FAIL" && magicPattern[i] && i === 0) ? 
        <div className="magic-icon" style={{ position: 'absolute', top: '-4px', left: '-2px', fontSize: '13px' }}>🦄</div> : null;

    return <div key={i} className={className} onClick={() => { if (!disabled) move(i) }}>{sharing ? " " : word[i] === ' ' ? shadow_word[i] : word[i] }{i === 0 ? magic_div : null}{i === 0 ? (rep_div === null ? exhausted_div : rep_div) : null}{i === word.length - 1 ? seq_div : null}{i === word.length - 1 ? n_div : null}{i === word.length - 1 && nextWordCount > 0 ? <div className="seq">{nextWordCount}</div> : null}</div>
  });
  return (

    <div className={"a" + (guessed_data === undefined ? "" : " dim") + (exhausted > 0 ? " dim" : (exhausted === -1) ? " fetching" : "") + (pendingOptConstraints ? " pending-constraints" : "")} style={{ gridTemplateColumns: `repeat(${n}, 1fr)` }}>
      {sharing ? share_button : null}
      {x}
    </div>
  );
}

export default Compose;

